import { Grid } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { PastVisitStatFilter, PastVisitStats } from 'v2/pages/Visits/utils/pastVisitStats';
import StatTile from './StatTile';

interface Props {
  stats: PastVisitStats;
  isLoading: boolean;
  selectedStat: PastVisitStatFilter;
  onStatClick: (stat: PastVisitStatFilter) => void;
}

const PastVisitStatTiles: React.FC<Props> = ({ stats, isLoading, selectedStat, onStatClick }) => {
  const { translation } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <StatTile
          value={stats.checkedIn}
          label={translation.qr_code_used}
          isLoading={isLoading}
          stat={PastVisitStatFilter.CheckedIn}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <StatTile
          value={stats.expired}
          label={translation.expired}
          isLoading={isLoading}
          stat={PastVisitStatFilter.Expired}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>
    </Grid>
  );
};

export default PastVisitStatTiles;
